import * as React from 'react';

import { useLockFn } from 'ahooks';
import { Button, Col, Flex, Form, notification, Row } from 'antd';

import { CheckOutlinedIcon, PrimitiveForm } from 'components';
import type { NoticeDto } from 'types';

import { updatePublicNotice } from '../../../../services';
import { NoticesSortableList } from '../notices-list';

type FieldType = {
  notices: NoticeDto[];
};

type NoticesInfoProps = {
  notices: NoticeDto[];
};

const NoticesInfo = ({ notices }: NoticesInfoProps) => {
  const [form] = Form.useForm<FieldType>();

  const onFinish = useLockFn(async ({ notices = [] }: FieldType) => {
    return updatePublicNotice({ notices: notices })
      .then(() => {
        notification.success({
          message: 'اطلاعات اطلاع‌رسانی با موفقیت ذخیره شد.',
        });
      })
      .catch(message => {
        notification.error({ message });
      });
  });

  return (
    <PrimitiveForm form={form} onFinish={onFinish}>
      <Row className='px-6 pt-2'>
        <Col span={24}>
          <Form.Item<FieldType>
            label='اعلان‌ها'
            name='notices'
            extra='اعلان‌ها را انتخاب کنید و با کشیدن، ترتیب نمایش آن‌ها را تغییر دهید. اعلان‌های فعال در بالای تمام صفحات سایت نمایش داده میشوند.'
            initialValue={notices}
          >
            <NoticesSortableList />
          </Form.Item>
        </Col>
      </Row>
      <Flex justify='end' className='px-6 pb-6'>
        <Form.Item className='mb-0'>
          <Button type='primary' htmlType='submit' icon={<CheckOutlinedIcon />}>
            ذخیره تغییرات
          </Button>
        </Form.Item>
      </Flex>
    </PrimitiveForm>
  );
};

export { NoticesInfo };
